import React from 'react'
import { Card, Col, ListGroup, Row } from 'react-bootstrap'

const Footer = () => {

  return (
    <>
        <footer className='no-border rounded-0 footer-wrapper'>
            <div className="footer-content container">
                <Row className='footer-top'>
                    <Col xs={{ span:4, offset:0 }} md={{ span:3, offset:0 }}>
                        <Card.Img className='' src={"/assets/footer/footer_paracosma _logo.png"} alt="" />
                    </Col>
                    <Col xs={{ span:4, offset:3 }} md={{ span:3, offset:5 }}>
                       <a href="https://www.facebook.com/paracosmaInc" target="_blank" rel="noreferrer"> <Card.Img className='footer-social-icon px-md-4' src={"/assets/footer/footer_fb.png"} alt="" /> </a>
                       <a href="https://www.instagram.com/paracosmainc" target="_blank" rel="noreferrer"> <Card.Img className='footer-social-icon px-md-4' src={"/assets/footer/footer_ig.png"} alt="" /> </a>
                       <a href="https://www.linkedin.com/company/paracosma/" target="_blank" rel="noreferrer"> <Card.Img className='footer-social-icon px-md-4' src={"/assets/footer/footer_linkedin.png"} alt="" /> </a>
                    </Col>
                </Row>

                <div className='product-border pt-4 pb-3'></div>
                <Row className='footer-mid-section py-2'>
                    <Col xs={{span:12,offset:0}} md={{span:4,offset:0}}>
                        <Card.Text className='footer-desc text-white pr-md-5 mr-md-5'>
                        パラコズマは、拡張現実（Augmented Reality）と仮想現実（Virtual Reality）のソリューション・プロバイダーです。パラコズマのサービスは、カスタムAR/VRアプリケーション開発、バーチャルオフィスやバーチャルイベントの制作、フォトリアルな3Dモデル作成だけでなく360°動画の作成や配信も行っています。2016年に設立されたパラコズマは、アメリカ、日本、ネパールのオフィスに100人以上の従業員を擁しています。
                        </Card.Text>
                    </Col>
                    <Col xs={{span:5,offset:0}} md={{span:3,offset:1}} className="footer-quicklink-container">
                        <Card.Title className='footer-mid-section-quicklink-header'> クイックリンク </Card.Title>
                        <ListGroup className='no-border quicklink-list text-white'>
                            <ListGroup.Item action href="https://www.paracosma.com" target="_blank"> ホーム </ListGroup.Item>
                            <ListGroup.Item action href="/jp/three-D-model"> 3Dモデル作成 </ListGroup.Item>
                            <ListGroup.Item action href="/jp/vr-development"> VR開発 </ListGroup.Item>
                            <ListGroup.Item action href="/jp/digital-twins"> デジタルツイン </ListGroup.Item>
                            <ListGroup.Item action href="https://www.paracosma.com/jp/#aboutus" target="_blank"> 会社概要 </ListGroup.Item>
                            <ListGroup.Item action href="https://blog.paracosma.com" target="_blank"> ブログ </ListGroup.Item>
                            <ListGroup.Item action href="https://www.paracosma.com/jp/#contact-form" target="_blank"> お問い合わせ </ListGroup.Item>
                        </ListGroup>
                    </Col>
                    <Col xs={{span:7,offset:0}} md={{span:4,offset:0}}>
                        <Card.Title className='footer-mid-section-header'> 事業所 </Card.Title>
                        <Row className='py-2'>
                            <Col xs={2}>
                                <Card.Img className='footer-social-icon px-md-4' src={"/assets/footer/footer_usa.png"} alt="" />
                            </Col>
                            <Col xs={10} className="footer-office-location text-white">
                            2 Clarence Place, Unit #12 <br /> San Francisco, CA 94107 USA
                            </Col>
                        </Row>
                        <Row className='py-2'>
                            <Col xs={2}>
                                <Card.Img className='footer-social-icon px-md-4' src={"/assets/footer/footer_japan.png"} alt="" />
                            </Col>
                            <Col xs={10} className="footer-office-location text-white">
                            〒143-0033 <br /> 
                            東京都品川区 <br /> 
                            西品川1-1-1 <br /> 
                            住友不動産大崎ガーデンタワー9階 <br /> 
                            トンネル東京気付 <br /> 
                            Paracosma株式会社
                            </Col>
                        </Row>
                        <Row className='py-2'>
                            <Col xs={2}>
                                <Card.Img className='footer-social-icon px-md-4' src={"/assets/footer/footer_nepal.png"} alt="" />
                            </Col>
                            <Col xs={10} className="footer-office-location text-white">
                            TBI Plaza Nagpokhari Marg 44600 <br /> Gairidhara, Kathmandu Nepal
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>

            <Row className='footer-bottom-section'>
                <Col sm={{span:6, offset:3}} className="footer-bottom-text">
                    © Copyright {new Date().getFullYear()} by <a href="https://www.paracosma.com"  rel="noreferrer">Paracosma, Inc</a>. All right reserved.
                </Col>
            </Row>
        </footer>
        
      
    </>
  )
}

export default Footer
